// extracted by mini-css-extract-plugin
export var opacity = "Aurora-orb01-module--opacity--cJHTs";
export var orb = "Aurora-orb01-module--orb--PeicF";
export var rotation = "Aurora-orb01-module--rotation--obx8S";
export var scaleX = "Aurora-orb01-module--scaleX--AHRvJ";
export var scaleY = "Aurora-orb01-module--scaleY--mk-Ty";
export var xaxis = "Aurora-orb01-module--xaxis--tABof";
export var yaxis = "Aurora-orb01-module--yaxis--oed64";